import React, { useState, useContext, useEffect } from "react";
import { Breadcrumb, Typography, Table, Button, Form, Input, DatePicker, Space, Card } from "antd";
import axios from "axios";
import { toast } from "react-toastify";
import { AuthContext } from "../../context/AuthContext";
import { AppliesToFields, appliesToPayload, useEmployeeOptions } from "../../components/hr/HolidayAppliesTo";

const { Title, Text } = Typography;

export default function AddHoliday() {
    const { authData, backUrl } = useContext(AuthContext);
    const employees = useEmployeeOptions();
    const NewHoliday = () => {
        const [form] = Form.useForm();
        const [submitting, setSubmitting] = useState(false);

        const addNewLeave = async (values) => {
            setSubmitting(true);
            try {
                const payload = {
                    year: values.year,
                    holiday_name: values.holiday_name,
                    holiday_day: values.holiday_day,
                    holiday_date: values.holiday_date.format("YYYY-MM-DD"),
                    ...appliesToPayload(values),
                };

                await axios.post(`${backUrl}/api/hr/holidays/`, payload, {
                    headers: { Authorization: `Bearer ${authData.access}` },
                });

                toast.success("Holiday added successfully!");
                form.resetFields();
            } catch (error) {
                console.error(error);
                const ids = error.response?.data?.employee_ids;
                toast.error(ids ? [].concat(ids).join(", ") : "Failed to add holiday!");
            } finally {
                setSubmitting(false);
            }
        };

        const handleDateChange = (date) => {
            if (date) {
                const year = date.year();
                const day = date.format("dddd");
                form.setFieldsValue({ year: year.toString(), holiday_day: day });
            } else {
                form.setFieldsValue({ year: "", holiday_day: "" });
            }
        };

        return (
            <div style={{ maxWidth: 800, margin: "0 auto", padding: "5px" }}>
                <Card
                    bordered={false}
                    style={{
                        borderRadius: "12px",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                        padding: "24px",
                    }}
                >
                    <div style={{ textAlign: "center", marginBottom: 24 }}>
                    </div>

                    <Form
                        form={form}
                        layout="vertical"
                        onFinish={addNewLeave}
                        requiredMark={false}
                    >
                        <Form.Item
                            name="holiday_name"
                            label="Holiday Name"
                            rules={[{ required: true, message: "Please enter holiday name" }]}
                        >
                            <Input placeholder="Enter holiday name" />
                        </Form.Item>

                        <Form.Item
                            name="holiday_date"
                            label="Holiday Date"
                            rules={[{ required: true, message: "Please select holiday date" }]}
                        >
                            <DatePicker
                                format="DD/MM/YYYY"
                                style={{ width: "100%" }}
                                onChange={handleDateChange}
                            />
                        </Form.Item>

                        <Form.Item name="year" label="Year">
                            <Input placeholder="Auto-filled year" disabled />
                        </Form.Item>

                        <Form.Item name="holiday_day" label="Holiday Day">
                            <Input placeholder="Auto-filled day" disabled />
                        </Form.Item>

                        <AppliesToFields formInstance={form} employees={employees} />

                        <Form.Item style={{ marginTop: 20 }}>
                            <Button
                                type="primary"
                                htmlType="submit"
                                loading={submitting}
                                block
                                style={{
                                    backgroundColor: "#0e497b",
                                    borderRadius: "8px",
                                    fontWeight: 500,
                                }}
                            >
                                Add Holiday
                            </Button>
                        </Form.Item>
                    </Form>
                </Card>
            </div>
        );
    };

    return (
        <>
            <NewHoliday />
        </>
    )
}